module.exports = __webpack_public_path__ + "static/media/click.1e5a63f0.mp3";